<div class="app-content content content-dssawere" *ngIf="isPageLoaded">
    <div class="content-overlay"></div>
    <div class="content-wrapper p-0">
        <div class="content-body">
            <section class="row flexbox-container">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="col-xxxxl-4 col-xxl-5 col-xl-6 col-md-8 col-10 box-shadow-2 p-0">
                        <div class="card px-1 py-1 m-0">
                            <div class="card-header d-block pb-0">
                                <div class="card-title text-center d-block">
                                    <img class="brand-logo" alt="branding logo" src="assets/images/logo/logo-contraste.png">
                                    <h3 class="brand-text">DSS-AWERE</h3>
                                </div>
                                <h6 class="card-subtitle line-on-side text-center fw-normal pt-2">
                                    <span>{{ 'login.subtitle' | translate }}</span>
                                </h6>
                            </div>
                            <div class="card-content">
                                <app-alert></app-alert>
                                <div class="card-body pb-2">
                                    <form class="form-horizontal" [formGroup]="loginForm" (ngSubmit)="tryLogin()">
                                        <fieldset class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text input-group-icon"><i class="la la-user"></i></span>
                                            </div>
                                            <input type="text" formControlName="email" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && f.email.errors }" id="user-name"
                                                placeholder="{{ 'login.usernamePlaceholder' | translate }}" required>
                                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                                <div *ngIf="f.email.errors.required">{{ 'validations.usernameRequired' | translate }}</div>
                                            </div>
                                        </fieldset>
                                        <fieldset class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text input-group-icon"><i class="la la-key"></i></span>
                                            </div>
                                            <input type="password" placeholder="{{ 'login.passwordPlaceholder' | translate }}"
                                            formControlName="password" class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                                <div *ngIf="f.password.errors.required">{{ 'validations.passwordRequired' | translate }}</div>
                                            </div>
                                        </fieldset>
                                        <div class="form-group row pb-2">
                                            <div class="col-sm-6 col-12 text-center text-sm-left pr-0">
                                                <fieldset>
                                                    <div class="custom-control custom-checkbox">
                                                        <input formControlName="rememberMe" type="checkbox" class="custom-control-input" id="remember-me">
                                                        <label class="custom-control-label fw-normal" for="remember-me">{{ 'login.rememberMe' | translate }}</label>
                                                    </div>
                                                </fieldset>
                                            </div>
                                            <div class="col-sm-6 col-12 text-center text-sm-right pl-0"><a
                                                [routerLink]="['/forgot-password']" class="card-link primary fw-bold">{{ 'login.forgotPassword' | translate }}</a>
                                            </div>
                                        </div>
                                        <button type="submit" class="btn btn-success btn-block" [disabled]="loading">
                                            <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
                                            <i class="feather ft-unlock" *ngIf="!loading"></i> {{ 'login.loginButton' | translate }}
                                        </button>
                                    </form>
                                    <p class="card-subtitle line-on-side text-center fw-normal my-3">
                                    <span>{{ 'login.newToPlatform' | translate }}</span></p>
                                    <a [routerLink]="['/register']" class="btn btn-danger btn-block"><i
                                            class="la la-user"></i> {{ 'login.registerButton' | translate }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    </div>
</div>